// Typed, user-safe error mapping. CLAUDE §7: user-facing copy is generic and never
// contains raw exception/DB text; the Edge Function returns stable codes and we map
// them to friendly messages here (single place to change copy/i18n later).
import type { SubmitErrorCode } from "./schemas/index.ts";

/** Codes the client can also originate (network/unknown) beyond the server's set. */
export type ClientErrorCode = SubmitErrorCode | "network" | "unknown";

const MESSAGES: Record<ClientErrorCode, string> = {
  validation_failed: "Please check the highlighted fields and try again.",
  turnstile_failed: "We couldn't verify you're human. Please retry the challenge.",
  rate_limited: "Too many attempts right now — please wait a moment and try again.",
  event_closed: "Entries for this event are closed.",
  duplicate: "Looks like you've already entered with this email. You're all set!",
  no_contact: "Please provide an email or phone number so we can reach you.",
  insert_failed: "Something went wrong saving your entry. Please try again.",
  code_required: "Enter the code from your entry card to continue.",
  code_invalid: "That code isn't recognized — check your entry card.",
  code_already_used: "This code has already been used.",
  method_not_allowed: "Something went wrong. Please refresh and try again.",
  network: "Network problem — check your connection and try again.",
  unknown: "Something went wrong. Please try again.",
};

export function messageForCode(code: string): string {
  return MESSAGES[code as ClientErrorCode] ?? MESSAGES.unknown;
}

/** Discriminated result used by the data layer instead of throwing across seams. */
export type Result<T> = { ok: true; value: T } | { ok: false; code: ClientErrorCode };

export const ok = <T>(value: T): Result<T> => ({ ok: true, value });
export const err = (code: ClientErrorCode): Result<never> => ({ ok: false, code });
